import React, { Component } from "react";
import "./App.css";
import Connectome from "./connectome";
import Header from "./header.js";

/* START Connectome Viewer Config Area

   Overwrite this section with the respective values from the README.md
   when deploying a specific version of the connectome viewer.md */

const title = "Dense connectomic reconstruction of layer 4 of the somatosensory cortex (v4)";
const webKnossosUrl =
  "https://webknossos.org/datasets/scalable_minds/l4dense_motta_et_al_demo_v2/sandbox/skeleton#2850,4318,1770,0,0.5";
const initialConnectionIndex = 31067;
const initialSynapseIndex = 0;

const scm = "scalable minds GmbH, D-14482 Potsdam, Germany.";
const mhlab =
  "Department of Connectomics, Max Planck Institute for Brain Research, D-60438 Frankfurt, Germany.";
const contributors = [
  { name: "scalable minds", institution: scm },
  { name: "Alessandro Motta", institution: mhlab },
];

/* END Connectome Viewer Config Area */

class App extends Component {
  render() {
    return (
      <div className="App">
        <Header title={title} contributors={contributors} />
        <Connectome
          webKnossosUrl={webKnossosUrl}
          initialConnectionIndex={initialConnectionIndex}
          initialSynapseIndex={initialSynapseIndex}
        />
      </div>
    );
  }
}

export default App;
